import { DataTable, Icon } from "components/common"
import { useEffect, useMemo, useState } from "react"
import { t } from "i18next"
import { useLazyGetInvoicedLeadsQuery } from "../api"
import { localisedValue } from "utils"
import { classifications } from "features/shared/data"

const InvoicedLeads = ({ invoiceId }) => {
  const [pageOffset, setPageOffset] = useState(0);
  const [getLeadsSummary, { data,isFetching,isLoading, error }] = useLazyGetInvoicedLeadsQuery();

  const onChangePage = (page) => {
    setPageOffset(page);
  };
  useEffect(() => {
    if (invoiceId) {
      getLeadsSummary({ id: invoiceId, pageOffset},true)
    }
  }, [invoiceId, pageOffset]);

  const invoicedLeadsColumns = useMemo(
    () => [
      { title: t("Lead Id"), dataIndex: "leadid", key: "leadid"},
      { title: t("Classification"), dataIndex: "classification", key: "classification"},
      { title: t("Client"), dataIndex: "client", key: "client"},
    ],
    []
  );

  const tableData = useMemo(
    () =>
      data?.data?.map((e) => {
        const classificationKey = e.classification?.key;
        const classificationDetails = classifications(true)[classificationKey];
        return {
          key: e.id,
          leadid: e.id,
          classification: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Icon
                icon="MdLocalFireDepartment"
                size="1.2em"
                color={classificationDetails?.style?.color}
                hasBackground={false}
              />
              <span style={{ marginLeft: "0.5em" }}>{classificationDetails?.name}</span>
            </div>
          ),
          client: localisedValue({ object: e, key: "clientName" }),
        };
      }) || [],
    [data]
  );

  return (
    <DataTable
      stickyOffset={-24}
      offsetHeader={110}
      tableLayout="auto"
      error={error}
      data={tableData}
      noUrlPush={true}
      loading={isFetching}
      columns={invoicedLeadsColumns || []}
      pagination={
        { totalCount: data?.count || 0, 
          pageOptions: [10], 
          page:pageOffset,
      }
    }
      onChangePage={onChangePage}
      onErrorRetry={()=>getLeadsSummary({ id: invoiceId, pageOffset})}
    />
  );
};
export default InvoicedLeads;